
/**
* Created by yoyo on 2017/12/11.
*/
import Vue from 'vue'
import axios from 'axios';
import Qs from 'qs';
import $ from 'jquery';
import api from "../api/api.js"
const key = 'webApp:webApp'
let Base64 = require('js-base64').Base64
let authKey = "";
let loginData=JSON.parse(localStorage.getItem("loginData"));
if(loginData){
  authKey = loginData.token_type+" "+loginData.access_token;
}else {
  authKey = 'Basic '+Base64.encode(key);
}
axios.defaults.headers.common['Authorization'] = authKey;
// axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
export default {
    commonAjax: function(options){
      let	that = this,
      url = '',
      method = 'POST',
      contentT='application/x-www-form-urlencoded',
      data = options.data;
            for(let Key in options){
                switch (Key){
                  case 'url':
                  url = options[Key];
                  break;
                  case 'type':
                  case 'method':
                  method = options[Key];
                  break;
                  case 'data':
                  data = options[Key];
                  break;
                  case 'token':
                  token = options[Key];
                  break;
                  case 'contentT':
                  contentT = options[Key];
                  break;
                  case 'success':
                  var successfn = options[Key];
                  break;
                  case 'error':
                  case 'fail':
                  var errorfn = options[Key];
                  break;
                  case 'unAuth':
                  var unAuthfn = options[Key];
                  break;
                }
            }
            axios({
                url : url,
                method : method,
                data : Qs.stringify(data),
            }).then((res) => {

                if(that.isString(res)){
                    try {
                        var oData = JSON.parse(res);
                    }
                    catch(e) {
                        oData = res;
                    }
                }else{
                    oData = res;
                }

                that.isFunction(successfn) && successfn(oData);

            }).catch((res) =>{

                that.isFunction(errorfn) && errorfn(res);
            });
            return false

    },
    JQajax: function(options){
      const key = 'webApp:webApp'
      let authKey = "";
      let loginData=JSON.parse(localStorage.getItem("loginData"));
      let nTime=Date.parse( new Date())/1000;
      if(loginData){
        authKey = loginData.token_type+" "+loginData.access_token;
      }else {
        authKey = 'Basic '+Base64.encode(key);
      }
      // console.log(loginData);
      let	that = this,
      url = '',
      method = 'POST',
      token=authKey,
      contentT='application/x-www-form-urlencoded',
      data = options.data;
          for(let Key in options){
              switch (Key){
                  case 'url':
                  url = options[Key];
                  break;
                  case 'type':
                  case 'method':
                  method = options[Key];
                  break;
                  case 'data':
                  data = options[Key];
                  break;
                  case 'token':
                  token = options[Key];
                  break;
                  case 'contentT':
                  contentT = options[Key];
                  break;
                  case 'success':
                  var successfn = options[Key];
                  break;
                  case 'error':
                  case 'fail':
                  var errorfn = options[Key];
                  break;
                  case 'unAuth':
                  var unAuthfn = options[Key];
                  break;
              }
          }
          if(loginData){
            // console.log(nTime-loginData.timestamp1);
            if(nTime-loginData.timestamp1>10000){
              // console.log(12345);
              api.refresh(unAuthfn)
            }
          }
          $.ajaxSetup({
               contentType:contentT,
               complete:function(XMLHttpRequest,textStatus){
                   //通过XMLHttpRequest取得响应头，sessionstatus，
                   // console.log(XMLHttpRequest,textStatus);
                   // var sessionstatus=XMLHttpRequest.getResponseHeader("sessionstatus");
                   if(XMLHttpRequest.status=="401"){
                       //如果超时就处理 ，指定要跳转的页面(比如登陆页)
                       // console.log();
                       api.refresh(unAuthfn)
                       // unAuthfn();
                   }
                }
             });
          $.ajax({
            url : url,
            type: method,
            contentType: contentT,
            data:data,
            beforeSend: function(xhr) {
              xhr.setRequestHeader("Authorization", token);
            },
            success: function(res) {
              if(that.isString(res)){
                  try {
                      var oData = JSON.parse(res);
                  }
                  catch(e) {
                      oData = res;
                  }
              }else{
                  oData = res;
              }
              that.isFunction(successfn) && successfn(oData);
            },

            error:function(res){
                that.isFunction(errorfn) && errorfn(res);
            }

        });

          return false
    },
    //原生js 实现 JSONP
    JSONP: function (options) {
        var url = '';
        var params = '';
        var callBack = '';
        for(let Key in options){
            switch (Key){
                case 'url':
                url = options[Key];
                break;
                case 'data':
                var arr = [];
                for(var dataKey in options[Key]){
                    arr.push(dataKey + '=' + options[Key][dataKey])
                }
                params = arr.join('&');
                break;
                case 'callback':
                callBack = '&callback=' + options[Key];
                break;
                case 'complate':
                var callBackFn = options["callback"];

                break;
            }
        }
        var script = document.createElement('script');
        script.setAttribute("type","text/javascript");
        if(/\?/.test(url)){
            script.src = url + params + callBack;
        }else{
            script.src = url + '?' + params + callBack;
        }
        document.body.appendChild(script);
        function callBackFn(res) {
            this.isFunction(options["complate"]) && callBackFn(res);
        }
    },
    isString: function (obj) {
        return Object.prototype.toString.call(obj) === "[object String]";
    },
    isFunction: function (obj) {
        return Object.prototype.toString.call(obj) === "[object Function]";
    },
    formatNum: function (strNum) {
                if(strNum<1000) {
                    return strNum;
                }
                if(!/^(\+|-)?(\d+)(\.\d+)?$/.test(strNum)) {
                    return strNum;
                }
                var a = RegExp.$1,
                    b = RegExp.$2,
                    c = RegExp.$3;
                var re = new RegExp();
                re.compile("(\\d)(\\d{3})(,|$)");
                while(re.test(b)) {
                    b = b.replace(re, "$1,$2$3");
                }
                return a + "" + b + "" + c;
            },
    formatMoney:function (num) {
     num = num.toString().replace(/\,/g,'');
     var sign = (num == (num = Math.abs(num)));
     num = Math.floor(num*100+0.50000000001);
     var cents=Math.abs(num%100),c;
     if(cents==0){
         c=""
     }else if(cents<10){
         c=".0"+cents
     }else{
         c="."+cents
     }
     num = Math.floor(num/100).toString();
     for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++){
         num = num.substring(0,num.length-(4*i+3))+','+num.substring(num.length-(4*i+3));
     }
     return (((sign)?"":'-') + num + c);
 }
}



// WEBPACK FOOTER //
// ./src/util/common.js